import React from 'react'
import {useSelector} from 'react-redux'
import {IReduxState} from '../../../redux/types/IReduxState'
import QueryResult from '../domain/QueryResult'
import classNames from 'classnames'
import {ResultInTable} from '../components/ResultInTable'

interface IMyResultProps {
  id: string
}

const MyResult: React.FC<IMyResultProps> = (): React.ReactElement => {
  const queryResultUser = useSelector<IReduxState, QueryResult | undefined>((state) => state.task?.queryResultUser)
  const queryResultSolution = useSelector<IReduxState, QueryResult | undefined>(
    (state) => state.task?.queryResultSolution,
  )
  const isQueryResultEquals = useSelector<IReduxState, boolean>((state) => state.task?.isQueryResultEquals)

  const css = classNames(
    'task-bottom-collapsible-block-body',
    'task-result-table',
    'task-result-table-user',
    isQueryResultEquals ? ' success' : ' error',
    'h-100',
  )

  return (
    <div className={css}>
      <ResultInTable isUserResult={true} data={queryResultUser} dataOther={queryResultSolution} />
    </div>
  )
}

export {MyResult}
